// extracted by mini-css-extract-plugin
export default {"loading":"image_loading__7vNVd","loading_animation":"image_loading_animation__i3mBk"};